import { executeRequest, Request } from '@jfs/network'
import { LoginParser } from './../network/parsers/LoginParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigPreAuth } from './config'

const responseParser = (data: any) => {
  const respData = LoginParser(data)
  return respData
}

const loginReq = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfigPreAuth(tokens),
    apiPath: APIEndPoints.Login,
    method: 'POST',
    body: req,
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.session) {
      return responseParser(data.data)
    } else {
      throw {
        data: {
          error: {
            code: data?.data?.code,
            message: data?.data?.message,
          },
        },
      }
    }
  })
}

export const userAuthApi = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfigPreAuth(tokens),
    apiPath: APIEndPoints.Login,
    method: 'POST',
    body: req,
  }
  return executeRequest(request).then((data) => {
    if (data?.httpCode === 200 && ['SUCCESS', 'INITIATED'].includes(data?.status?.toUpperCase())) {
      return data.data
    } else {
      throw {
        data: {
          error: {
            code: data?.data?.code,
            message: data?.data?.message,
          },
        },
      }
    }
  })
}

export { loginReq }
